<template>
  <cell-base
    :draggable="!(job.isCompleted || job.isCancelled)"
    :class="cellClassNames"
    :week-start="weekStart"
    :start="job.displayedStartTime"
    :end="job.displayedEndTime"
    :color="colour"
    :is-saving="job.isSaving"
    @click.native.exact.stop="onClick"
    @click.native.meta.stop="onCtrlClick"
    @click.native.ctrl.stop="onCtrlClick"
    @contextmenu.native.capture.prevent.stop="onContextMenu"
    @drag.capture.stop="onDrag"
  >
    <template #default>
      <event-cell-job-details :week-start="weekStart" :job="job" />
      <div v-if="job.isCompleted || job.isCancelled" class="icon">
        <v-icon v-if="job.isCompleted" small color="green" data-test="cell-icon"
          >mdi-check-circle-outline
        </v-icon>
        <v-icon v-if="job.isCancelled" small color="red" data-test="cell-icon"
          >mdi-close-circle-outline
        </v-icon>
      </div>
      <event-cell-job-progress-bar :item="job" />
    </template>
    <template #popover>
      <event-job-details-card :item="job" />
    </template>
  </cell-base>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Moment } from 'moment'
import CellBase from '@/components/weekly-schedule/calendar/CellBase.vue'
import { Item } from '@/components/weekly-schedule/utils'
import EventJobDetailsCard from '@/components/weekly-schedule/EventJobDetailsCard.vue'
import EventCellJobProgressBar from '@/components/weekly-schedule/EventCellJobProgressBar.vue'
import EventCellJobDetails from '@/components/weekly-schedule/EventCellJobDetails.vue'

const props = defineProps<{
  job: Item
  weekStart: Moment
}>()

const emit = defineEmits<{
  (event: 'click:job', job: Item): void
  (event: 'select:job', job: Item, mouseEvent: MouseEvent): void
  (event: 'context:job', job: Item, mouseEvent: MouseEvent): void
  (event: 'drag:job', job: Item, dragEvent: DragEvent): void
}>()

const cellClassNames = computed(() => {
  return {
    'is-crossed-out': props.job.isCompleted || props.job.isCancelled,
    'new-priority': props.job.priority.name === 'New',
    selected: props.job.isSelected,
  }
})
const colour = computed<string | undefined>(() => props.job.division?.hexCode ?? undefined)
const onClick = () => emit('click:job', props.job)
const onCtrlClick = (mouseEvent: MouseEvent) =>
  // const isMac = /Mac/.test(navigator.userAgent)
  emit('select:job', props.job, mouseEvent)
const onContextMenu = (mouseEvent: MouseEvent) => emit('context:job', props.job, mouseEvent)
const onDrag = (dragEvent: DragEvent) => emit('drag:job', props.job, dragEvent)
</script>

<style scoped>
.is-crossed-out {
  background-color: var(--color-silver);
}

.cell.is-crossed-out :deep(.content) {
  color: var(--color-grey);
  text-decoration: line-through;
}
</style>
